import L from "leaflet";
import { ImageOverlay, MapContainer, Marker } from "react-leaflet";
import { useEffect, useState, useContext, useMemo, useRef } from "react";
import {
  expireAuthToken,
  getPlantMapImageUrl,
  mapCoordinate,
  timeFrameFormatter
} from "../../util/helper/helperFunctions";
import "../../assets/css/TimeMachine/timeMachine.css";
import { lgvHistoryStatus } from "../../util/network/apiUrl";
import { AppContext } from "../../Context/Context";
import TimeMachineController from "../Modal/TimeMachineController/TimeMachineController";
import LgvIcon from "../LgvIcon/LgvIcon";
import ReactDOMServer from "react-dom/server";
import zoomInIcon from "../../assets/icons/add.png";
import zoomOutIcon from "../../assets/icons/minus.png";
import zoomRefreshIcon from "../../assets/icons/refresh.png";
import { DB_ERROR } from "../../util/helper/constants";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setCurrentPageCount,
  setCurrentPageTimeMachineData,
  setGroupDataCount,
  setGroupDataCurrentCount,
  setIsTimeMachineDataAvailable,
  setSeekPosition,
  setTimeMachineDataAvailable,
  setTimeMachineDataFetchComplete,
  setTimeMachineLoader,
  setTimeMachineModeIsEnabled,
  setTimeMachineState,
  setTotalSeekPosition
} from "../../store/oldTimeMachineSlice";
import { setTimeRangeType } from "../../store/plantSlice";
import { store } from "../../store";
import { AXIOS } from "../../util/network/axiosInstance";

const TimeMachine = () => {
  const { plantCode } = useParams();
  const dispatch = useDispatch();

  //oldTime machine redux values
  const {
    groupDataCurrentCount,
    groupDataCount,
    seekPosition,
    totalSeekPosition,
    timeMachineState,
    timeMachineLoader,
    isTimeMachineDataAvailable,
    currentPageCount,
    timeMachineDataFetchComplete
  } = useSelector((state) => state.oldTimeMachine);

  //Context API
  const { timeMachineTimeFrames, setTimeRangePopup, timeRangePopup } =
    useContext(AppContext);

  const [startTimeFrameIsAvailable, setStartTimeFrameIsAvailable] = useState(
    timeMachineTimeFrames && timeMachineState
      ? Object.keys(timeMachineTimeFrames).length !== 0
        ? true
        : false
      : false
  );
  const [timeMachineData, setTimeMachineData] = useState([]);
  const [groupIteratingInterval, setGroupIteratingInterval] = useState(null);

  const [totalPagesCount, setTotalPagesCount] = useState(0);

  const wrapperRef = useRef(null);

  //Plant Config
  const { plantConfig } = useContext(AppContext);
  //Plant Image Config
  const { appConfig } = useContext(AppContext);

  let auth = JSON.parse(localStorage.getItem("auth"));
  const [mapObject, setMapObject] = useState();
  const [isMapDraggable, setIsMapDraggable] = useState(false);
  const [convertedSocketData, setConvertedSocketData] = useState();

  useEffect(() => {
    dispatch(setSeekPosition(0));

    dispatch(setTotalSeekPosition(1));

    dispatch(setTimeMachineDataAvailable(true));

    dispatch(setTimeMachineDataFetchComplete(false));

    dispatch(
      setCurrentPageTimeMachineData({
        pageSize: 0,
        data: ["startData"]
      })
    );

    dispatch(setCurrentPageCount(1));

    dispatch(setGroupDataCount(0));

    dispatch(setGroupDataCurrentCount(0));
    setTotalPagesCount(0);
  }, [timeMachineTimeFrames]);

  const groupLgvPageData = (filteredData) => {
    let groupedData = {};
    for (const item of filteredData) {
      const itemName = item.TRN_DTTM;
      if (!groupedData[itemName]) {
        groupedData[itemName] = [];
      }
      groupedData[itemName].push(item);
    }

    Object.entries(groupedData).forEach(([key, value]) => {
      value.sort((a, b) => a.LGV_ID - b.LGV_ID);
    });
    let filteredGroup = {};
    Object.entries(groupedData).forEach(([key, value]) => {
      if (value.length == groupedData[Object.keys(groupedData)[1]].length) {
        filteredGroup[key] = value;
      }
    });
    dispatch(setGroupDataCount(Object.keys(filteredGroup).length));
    return filteredGroup;
  };

  // const hasMountedRef = useRef(false); // Guard for initial double-run in dev

  useEffect(() => {
    if (!startTimeFrameIsAvailable && !timeRangePopup) {
      setTimeRangePopup(true);
      dispatch(setTimeMachineModeIsEnabled(true));
      dispatch(setTimeRangeType("timeMachine"));
    }
  }, []);

  useEffect(() => {
    if (!startTimeFrameIsAvailable || !timeMachineState) return;

    const { fromTimePlant, toTimePlant } = timeFrameFormatter(
      timeMachineTimeFrames
    );

    const iterateGroupedData = (groupedData) => {
      dispatch(setGroupDataCurrentCount(0));

      const intervalId = setInterval(() => {
        const state = store.getState().oldTimeMachine;
        const groupDataCount = state.groupDataCount;
        const groupDataCurrentCount = state.groupDataCurrentCount;

        if (groupDataCurrentCount < groupDataCount) {
          setTimeMachineData(Object.values(groupedData)[groupDataCurrentCount]);
          dispatch(setGroupDataCurrentCount(groupDataCurrentCount + 1));
        } else {
          dispatch(setGroupDataCurrentCount(0));
          clearInterval(intervalId);
        }
      }, 1000);

      setGroupIteratingInterval(intervalId);

      dispatch(setSeekPosition(Number(currentPageCount)));
      dispatch(setCurrentPageCount(currentPageCount + 1));
    };

    const getCurrentPageData = async (pageSize) => {
      try {
        dispatch(setTimeMachineDataFetchComplete(true));

        const timeMachineDataResp = await AXIOS.get(
          `${lgvHistoryStatus}/${fromTimePlant}/${toTimePlant}/${pageSize}?location=${plantCode}`
        );

        if (
          timeMachineDataResp.status === 200 &&
          timeMachineDataResp.data !== DB_ERROR
        ) {
          if (timeMachineDataResp.data.results.length !== 0) {
            if (pageSize === 1) {
              setTotalPagesCount(timeMachineDataResp.data.totalPages);
              dispatch(
                setTotalSeekPosition(timeMachineDataResp.data.totalPages)
              );
            }

            dispatch(setGroupDataCurrentCount(0));
            iterateGroupedData(
              groupLgvPageData(timeMachineDataResp.data.results)
            );
            dispatch(setTimeMachineLoader(false));
            dispatch(setIsTimeMachineDataAvailable(true));
          } else {
            dispatch(setTimeMachineDataAvailable(false));
            dispatch(setIsTimeMachineDataAvailable(false));
          }
        } else if (timeMachineDataResp.status === 401) {
          expireAuthToken();
        } else if (timeMachineDataResp.status !== 400) {
          getCurrentPageData(pageSize);
        }
      } catch (err) {
        console.error("API call failed:", err);
      } finally {
        dispatch(setTimeMachineDataFetchComplete(false));
      }
    };

    const reduxState = store.getState().oldTimeMachine;

    if (
      reduxState.groupDataCurrentCount === reduxState.groupDataCount &&
      !timeMachineDataFetchComplete
    ) {
      clearInterval(groupIteratingInterval);
      getCurrentPageData(currentPageCount);
    }
  }, [
    plantCode,
    timeMachineTimeFrames,
    currentPageCount,
    totalPagesCount,
    startTimeFrameIsAvailable,
    timeMachineState,
    seekPosition,
    groupDataCurrentCount,
    groupDataCount,
    auth.accessToken
  ]);

  useEffect(() => {
    if (seekPosition == totalSeekPosition) {
      dispatch(setTimeMachineState(false));
    }
  }, [seekPosition, totalSeekPosition]);

  const filterDuplicatesAndNoCoordinates = (rawData) => {
    let noCoordinatesFiltered = rawData.filter((data) => data["X"] !== null);
    let noDuplicatesFiltered = noCoordinatesFiltered.filter(
      (data, index, self) => {
        let firstInstance = self.findIndex(
          (innerObject) => innerObject["LGV_ID"] === data["LGV_ID"]
        );
        return index === firstInstance;
      }
    );
    return noDuplicatesFiltered;
  };

  useEffect(() => {
    if (timeMachineTimeFrames && timeMachineState) {
      if (Object.keys(timeMachineTimeFrames).length !== 0) {
        setStartTimeFrameIsAvailable(true);
      }
    }
  }, [timeMachineTimeFrames, timeMachineState]);

  const convertReactComponentToHtmlIcon = (
    reactComponent,
    className,
    iconSize,
    iconAnchor
  ) => {
    const reactToHtml = ReactDOMServer.renderToString(reactComponent);
    return L.divIcon({
      className: className,
      iconSize: iconSize,
      iconAnchor: iconAnchor ? iconAnchor : null,
      html: reactToHtml
    });
  };

  useEffect(() => {
    if (timeMachineData) {
      if (plantConfig) {
        const { lgvs } = plantConfig.indoorMap;
        const { bounds } = lgvs;

        if (mapObject && timeMachineData) {
          let filteredData = filterDuplicatesAndNoCoordinates(timeMachineData);
          filteredData.map((marker, index) => {
            let convertedCoordinates = mapCoordinate(
              marker["X"],
              marker["Y"],
              "lgv",
              bounds
            );
            let convertedPoints = L.point(
              convertedCoordinates.x,
              convertedCoordinates.y
            );
            let convertedLatLng =
              mapObject.map.target.layerPointToLatLng(convertedPoints);
            marker.currentPos = {
              lat: convertedLatLng.lat,
              lng: convertedLatLng.lng
            };
          });
          setConvertedSocketData(filteredData);
        }
      }
    }
  }, [timeMachineData, mapObject, plantConfig]);

  const RenderLgv = useMemo(() => {
    if (plantConfig && convertedSocketData) {
      //Get Plant's LGV Config
      const { lgvs } = plantConfig.indoorMap;
      //LGV's Marker and Group offset values
      const { marker, groupOffset } = lgvs;
      // const { marker, groupOffset } = plantConfig;
      return convertedSocketData.map((lgv, index) => {
        let reactIcon = convertReactComponentToHtmlIcon(
          <LgvIcon data={lgv["LGV_ID"]} status={""} />,
          "blinking",
          marker.size,
          [42.5, 50]
        );
        let lgvCorrection = groupOffset;
        return (
          <Marker
            key={index}
            riseOnHover
            position={[
              lgv.currentPos.lat + lgvCorrection.x,
              lgv.currentPos.lng + lgvCorrection.y
            ]}
            icon={reactIcon}
          ></Marker>
        );
      });
    }
  }, [plantConfig, convertedSocketData]);

  const centerMapView = (unit1, unit2) => {
    let convertedCoordinates;
    if (unit1 && unit2) {
      convertedCoordinates = mapCoordinate(unit1, unit2);
    } else {
      convertedCoordinates = mapCoordinate(275000, 70000);
    }
    let convertedPoints = L.point(
      convertedCoordinates.x,
      convertedCoordinates.y
    );
    let convertedLatLng =
      mapObject.map.target.layerPointToLatLng(convertedPoints);
    mapObject.map.target.setView([convertedLatLng.lat, convertedLatLng.lng]);
  };

  useEffect(() => {
    if (mapObject) {
      centerMapView();
    }
  }, [mapObject]);

  const RenderMap = useMemo(() => {
    if (appConfig && plantConfig && mapObject && plantCode) {
      let img = getPlantMapImageUrl(appConfig, plantCode, "WAREHOUSE_MAP");
      const { mapBg } = plantConfig.indoorMap;
      if (img && mapBg) {
        //Get Image, Image Bounds (limit), X1,Y1 , X2,Y2 coordinates of image and Image bg color
        const { bounds, coordinates } = mapBg;
        //(X1,Y1) and (X2,Y2) data of map coordinates
        const { startX, startY, endX, endY } = coordinates;

        //Downscale start coordinate
        let startConvertedCoordinates = mapCoordinate(
          startX,
          startY,
          "map",
          bounds
        );
        let startConvertedPoints = L.point(
          startConvertedCoordinates.x,
          startConvertedCoordinates.y
        );
        let startConvertedLatLng =
          mapObject.map.target.layerPointToLatLng(startConvertedPoints);

        //Downscale end coordinate
        let endConvertedCoordinates = mapCoordinate(endX, endY, "map", bounds);
        let endConvertedPoints = L.point(
          endConvertedCoordinates.x,
          endConvertedCoordinates.y
        );
        let endConvertedLatLng =
          mapObject.map.target.layerPointToLatLng(endConvertedPoints);

        //Final Downscaled bounds for Image
        let overlayBounds = [
          [startConvertedLatLng.lat, startConvertedLatLng.lng],
          [endConvertedLatLng.lat, endConvertedLatLng.lng]
        ];
        return <ImageOverlay url={img} bounds={overlayBounds} />;
      }
    }
  }, [appConfig, plantConfig, mapObject, plantCode]);

  const MIN_ZOOM = 1.0;
  const MAX_ZOOM = 2.0;
  const ZOOM_STEP = 0.2;

  const [currentZoom, setCurrentZoom] = useState(1.0);

  const applyZoom = (zoomValue) => {
    const container = wrapperRef.current;
    document.getElementById(
      "time-machine-map-id-reference"
    ).style.transform = `scale(${zoomValue})`;
    if (container)
      container.style.cursor =
        zoomValue === MIN_ZOOM || zoomValue === MAX_ZOOM ? "default" : "grab";
  };

  useEffect(() => {
    applyZoom(currentZoom); // initial mount
  }, []);

  const zoomIn = () => {
    const nextZoom = Math.min(currentZoom + ZOOM_STEP, MAX_ZOOM);
    setCurrentZoom(nextZoom);
    applyZoom(nextZoom);
    setIsMapDraggable(true);
    centerMapView();
  };

  const zoomOut = () => {
    const nextZoom = Math.max(currentZoom - ZOOM_STEP, MIN_ZOOM);
    setCurrentZoom(nextZoom);
    applyZoom(nextZoom);
    setIsMapDraggable(true);
    centerMapView();
  };

  const resetZoom = () => {
    setCurrentZoom(MIN_ZOOM);
    applyZoom(MIN_ZOOM);
  };

  useEffect(() => {
    const slider = wrapperRef.current;
    let mouseDown = false;
    let startX, scrollLeft, startY, scrollTop;

    let startDragging = function (e) {
      mouseDown = true;
      startX = e.pageX - slider.offsetLeft;
      startY = e.pageY - slider.offsetTop;
      scrollTop = slider.scrollTop;
      scrollLeft = slider.scrollLeft;
    };
    let stopDragging = function (event) {
      mouseDown = false;
    };

    const handleMouseMove = (e) => {
      e.preventDefault();
      if (!mouseDown) return;

      const x = e.pageX - slider.offsetLeft;
      const y = e.pageY - slider.offsetTop;

      const scrollX = x - startX;
      const scrollY = y - startY;

      slider.scrollLeft = scrollLeft - scrollX;
      slider.scrollTop = scrollTop - scrollY;
    };

    slider.addEventListener("mousemove", handleMouseMove);
    slider.addEventListener("mousedown", startDragging);
    slider.addEventListener("mouseup", stopDragging);
    slider.addEventListener("mouseleave", stopDragging);

    return () => {
      slider.removeEventListener("mousemove", handleMouseMove);
      slider.removeEventListener("mousedown", startDragging);
      slider.removeEventListener("mouseup", stopDragging);
      slider.removeEventListener("mouseleave", stopDragging);
    };
  }, []);

  return (
    <div className="map-container-wrapper">
      <div
        id="time-machine-map-container-id"
        className="time-machine-container"
        ref={wrapperRef}
      >
        {timeMachineLoader ? (
          <div className="loader">
            {!startTimeFrameIsAvailable || seekPosition == totalSeekPosition ? (
              <h4>Please Select Time Frame to Initiate Time Machine..</h4>
            ) : isTimeMachineDataAvailable ? (
              <>
                <h4>Fetching All LGVs...</h4>
                <div className="spinner"></div>
              </>
            ) : (
              <h4>
                No Data Available! <br /> Please select a different Time
                Range...
              </h4>
            )}
          </div>
        ) : null}
        <MapContainer
          id="time-machine-map-id-reference"
          style={{ height: "100%", width: "100%", borderRadius: "10px" }}
          center={[0, 0]}
          zoom={0}
          maxZoom={3}
          crs={L.CRS.Simple}
          attributionControl={false}
          scrollWheelZoom={false}
          whenReady={(map) => setMapObject({ map })}
          dragging={true}
          zoomControl={false}
        >
          {RenderMap}
          {RenderLgv}
        </MapContainer>
      </div>
      {isTimeMachineDataAvailable && <TimeMachineController />}
      <div className="zoom-control-center">
        <button
          className="zoom-controls zoom-in-control"
          disabled={currentZoom >= MAX_ZOOM}
          onClick={() => zoomIn()}
        >
          <img src={zoomInIcon} />
        </button>
        <button
          className="zoom-controls zoom-out-control"
          disabled={currentZoom <= MIN_ZOOM}
          onClick={() => zoomOut()}
        >
          <img
            style={{ opacity: currentZoom <= MIN_ZOOM == true ? "0.5" : "1" }}
            src={zoomOutIcon}
          />
        </button>
        <button
          className="zoom-controls zoom-reset-controls"
          disabled={currentZoom <= MIN_ZOOM}
          onClick={() => resetZoom()}
        >
          <img
            style={{ opacity: currentZoom <= MIN_ZOOM == true ? "0.5" : "1" }}
            src={zoomRefreshIcon}
          />
        </button>
      </div>
    </div>
  );
};

export default TimeMachine;
